import { BigNumber } from 'ethers'
import { bigDiv, formatBigNumber } from 'utils'
import { MaxValues } from '..'
import { ACTION, ACTION_TYPES } from '../borrowActions'

export const EXIT_PROMPT_RATIO = 0.95
// If they are repaying or withdrawing over 95% (EXIT_PROMPT_RATIO) of their position, suggest an exit
export function isPotentialExit(
  action: ACTION,
  input: BigNumber | undefined,
  maxValues: MaxValues,
) {
  if (!input || !maxValues[action.value] || maxValues[action.value].isZero()) {
    return false
  }

  if (action.value === ACTION_TYPES.REPAY || action.value === ACTION_TYPES.WITHDRAW) {
    const exitRatio = Number(formatBigNumber(bigDiv(input, maxValues[action.value])))
    return exitRatio > EXIT_PROMPT_RATIO
  }

  return false
}
